import { ConfigInitializer } from '@spartacus/core';
import { Injectable } from '@angular/core';
import { map, firstValueFrom } from 'rxjs';

import { ConfigurationService } from '../../services';

@Injectable()
export class BaseConfigInitializer implements ConfigInitializer {
  scopes = ['backend.occ.baseUrl'];

  constructor(private configurationService: ConfigurationService) {}

  configFactory(): Promise<any> {
    return firstValueFrom(
      this.configurationService.getConfig().pipe(
        map((config) => ({
          backend: {
            occ: {
              baseUrl: config.occBaseUrl,
              useWithCredentials: true
            }
          }
        }))
      )
    );
  }
}
